import React from "react";

const CheckBox = ({ name, value, checked, onChange, classname, disabled}) => {
  return (
    <div className={`${classname ? classname : "field-radio-block"}`}>
      <label className={`checkbox checkbox-outline-primary mb-0 ${disabled ? 'disabled' : ''}`}>{value}
        <input name={name} type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
        <span className="checkmark"></span>
      </label>
    </div>
  );
};

export default CheckBox;

export const CheckBoxAlert = ({ name, value, checked, onChange, classname, disabled}) => {
  return (
    <div className={`${classname ? classname : "field-radio-block"}`}>
      <label className={`checkbox checkbox-outline-primary mb-0 ${disabled ? 'disabled' : ''}`} style={{color:'#000',fontSize:'14px',fontWeight:'700'}}>{value}
        <input name={name} type="checkbox" checked={checked} onChange={onChange} disabled={disabled} style={{borderColor:'#000'}}/>
        <span className="checkmark"></span>
      </label>
    </div>
  );
};